import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AuthService = /** @class */ (function () {
    function AuthService(http) {
        this.http = http;
        this.apiBase = environment.apiHost + '/makpak';
    }
    // Exchanges authorization code for CIAM login token
    AuthService.prototype.sendAuthCode = function (authCode) {
        return this.http.post(this.apiBase + "/auth/code", { authCode: authCode }, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            observe: 'response'
        });
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.HttpClient)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
